// extracted by mini-css-extract-plugin
export default {"slideBox":"Slider_slideBox__aE3Ul","leftSlide":"Slider_leftSlide__YblQp","rightSlide1":"Slider_rightSlide1__hIPrj","rightSlide2":"Slider_rightSlide2__NDKkM"};